import { Button, MyTableComponent } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const GreenWaves = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: "",
   infotwo: "",
   infothree: "",
  },
  {
   infoone: "",
   infotwo: "",
   infothree: "",
  },
  {
   infoone: "",
   infotwo: "",
   infothree: "",
  },
  {
   infoone: "",
   infotwo: "",
   infothree: "",
  },
 ]

 const columns = [
  { Header: t("greenRibbonName"), accessor: "infoone" },
  { Header: t("investments"), accessor: "infotwo" },
  { Header: t("creator"), accessor: "infothree" },
 ]

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <h1 className="font-semibold text-2xl Jakarta-font py-5">{t("processGreenBelt")}</h1>
   <div className="">
    <Box
     bg="highlight"
     className="flex lg:flex-row flex-col lg:justify-between lg:items-center py-4 px-2"
    >
     <h1 className="Jakarta-font font-bold text-xl">{t("period")}</h1>
     <div className="flex lg:flex-row flex-col">
      <div className=" lg:mr-2">
       <Button size={"doublexl"}>Forum Gera</Button>
      </div>
      <Box bg="text" className="rounded lg:py-0 py-2">
       <Button size={"doublexl"} color={"gray"}>
        Test Server
       </Button>
      </Box>
     </div>
    </Box>
   </div>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
   <Box bg="highlight" className="flex justify-end py-2">
    <div>
     <Button size={"doublexl"}>{t("new")}</Button>
    </div>
   </Box>
  </div>
 )
}
